import { Component, ElementRef, HostListener, Input, OnInit, Renderer2 } from '@angular/core';
import { ModalService } from '../modal.service';

@Component({
  selector: 'modal-open-point',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})

export class ModalComponent implements OnInit {
  @Input() deshabilitarClickFueraDeContexto : boolean
  @Input() mode: string;
  @Input() id: string;
  constructor(private modalService: ModalService, private el: ElementRef, private render: Renderer2) {
    this.mode = this.mode || 'normal'
    this.openModal = false;
    if(this.deshabilitarClickFueraDeContexto === undefined){
      this.deshabilitarClickFueraDeContexto = false;
    }
  }

  ngOnInit(): void {
    // ensure id attribute exists
    if (!this.id) {
      return;
    }
    this.render.addClass(this.el.nativeElement, 'notvisible');
    if (this.mode === 'normal') {
      this.render.appendChild(document.body, this.el.nativeElement);
    }    
    this.modalService.add(this);
  }

  /* // close modal on background click
   @HostListener('click') onClick() {
       if (this.el.nativeElement.target.className === 'modal') {
           this.close();
       }
   }*/


  // remove self from modal service when component is destroyed
  ngOnDestroy(): void {
    this.remove()
    //this.el.nativeElement.remove();
  }
  remove() {
    this.modalService.remove(this.id);
    var parentnode = this.render.parentNode(this.el.nativeElement);
    //console.log(parentnode);
    this.render.removeChild(parentnode, this.el.nativeElement);
  }
  // open modal
  open(): void {
    // Antes esto pisaba TODO el style.cssText del body ('overflow: hidden;'
    // a secas), borrando cualquier otro estilo inline que otro codigo le
    // hubiera puesto al body (ej. el lock de scroll del carrito en mobile,
    // que fija position:fixed+top). Con una clase en vez de cssText, ambos
    // mecanismos conviven sin pisarse.
    if (this.mode != "noBackground") {
      document.body.classList.add('modal-body-lock');
    }
    this.render.addClass(this.el.nativeElement, 'visible');
    this.openModal = true;
  }

  // close modal
  close(): void {
    document.body.classList.remove('modal-body-lock');
    this.render.removeClass(this.el.nativeElement, 'visible');
    this.openModal = false;
    //this.remove();
  }

  closeControl() {
    if(this.deshabilitarClickFueraDeContexto){
      return
    }
    if (this.id != 'modal-error' && this.id != 'spinner-modal') {
      this.close();
    }
  }

  /* @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    //console.log(event.key);
    if (event.key === "Escape") {
      if (this.id != 'modal-error' && this.id != 'spinner-modal') {
        this.close();
      }
    }
  } */
  get isOpen() {
    return this.openModal;
  }
  private openModal: boolean;

}
